import { IconButton } from "@mui/material";
import React from "react";
import PhotoCamera from "@mui/icons-material/PhotoCamera";

function ImageInput({ onChange = () => {}, hidden = false }) {
  return (
    <IconButton color="primary" component="label" hidden={hidden}>
      <input
        hidden
        accept="image/*"
        type="file"
        onChange={(e) => onChange(e)}
      />
      <PhotoCamera />
    </IconButton>
  );
}

export default ImageInput;
